import React, { useEffect, useState, useRef } from "react"
import cx from "classnames"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import Collapsible from "@/components/core/Collapsible"
import printIcon from "@/public/icons/print.svg"
import shareIcon from "@/public/icons/share.svg"
import filterIcon from "@/public/icons/filter.svg"
import { getShortenedUrl } from "@/utils/helper"
import closeIcon from "@/public/icons/close-filter.svg"
import { entityToCharacter } from "@/components/FriendsAndFamily/v1/friendsAndFamilyHelper"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import { isMobile, isTablet } from "react-device-detect"
import searchIcon from "@/public/icons/search.svg"
import { addDataLayer, getSocialAnalyticsData } from "../analytics"

const Filter = props => {
  const [showMore, setShowMore] = useState(false)
  const [showAllCollection, setShowAllCollection] = useState({})
  const [collapse, setCollapse] = useState({})
  const [appliedFilters, setAppliedFilters] = useState([])
  const plus = (
    <section className="plus">
      <div className="line-1 line"></div>
      <div className="line line-2"></div>
    </section>
  )
  const [showSocialLink, setShowSocialLink] = useState(false)
  const [collectionFilterValue, setCollectionFilterValue] = useState({})
  const collectionSearchVal = useRef(0)
  const shareImg = useRef(null)

  const formatFacetName = (name, filter) => {
    let val = (props?.facetLabels && props?.facetLabels[name?.replace(/^\*{2}/, '')])
        ? props?.facetLabels[name?.replace(/^\*{2}/, '')]
        : name?.replace(/\./g, '/')?.replace(/_/g, ' ')?.replace(/^\*{2}/, '')
    if (filter) val += ` - ${filter}`
    return val
  }

  useEffect(() => {
    if (props.currFilters && props.currFilters.length > 0) {
      setAppliedFilters(props.currFilters)
    }
  }, [props.currFilters])

  //delete unwanted facets
  let filterList = props.facets

  delete filterList["New_Products"]
  delete filterList["Available_Now"]
  delete filterList["**Products"]
  delete filterList["**Inspiration"]
  delete filterList["**Technical"]
  delete filterList["**Parts"]
  delete filterList["**Help"]
  delete filterList["**Resource"]

  const userGroup = ["ANY", "CTR", "FF", "GST", "KEMP", "KYS", "TPR", "TVS"]

  userGroup.forEach(group => {
    delete filterList[`${group}_Price_Range`]
  })

  if (props.hidePriceRange) {
    delete filterList["Price_Range"]
  } else if (filterList["Price_Range"]) {
    filterList = { Price_Range: filterList[`Price_Range`], ...filterList }
  }

  let facets = Object.entries(filterList).filter(facet => facet[1].length > 0)
  const getAppliedFiltersForAnalytics = appliedFilters => {
    let filterArray = []
    appliedFilters.forEach(filter => {
      filter.display.forEach(filtervalue => {
        filterArray.push(
          `${formatFacetName(facetLabels[filter.facet])}:${filtervalue}`
        )
      })
    })
    return filterArray.length ? filterArray.join("|") : ""
  }
  const isSelected = obj => {
    let facet = appliedFilters.find(filter => filter.facet === obj.facet)
    if (!facet) return false
    return facet.display.includes(obj.display) ? true : false
  }

  const handleFilter = (checked, obj, needClearAllDataLayer = true) => {
    let curFilters = appliedFilters
    let facet = curFilters.find(filter => filter.facet === obj.facet)
    if (checked) {
      if (facet) {
        facet.value.push(obj.value.replace(/"/g, '\\"'))
        facet.display.push(obj.display)
      } else
        curFilters.push({
          facet: obj.facet,
          value: [obj.value.replace(/"/g, '\\"')],
          display: [obj.display],
        })
    } else {
      let index = facet.display.indexOf(obj.display)
      facet.value.splice(index, 1)
      facet.display.splice(index, 1)

      if (!facet.value.length) {
        curFilters = curFilters.filter(f => f.facet !== obj.facet)
      }
    }

    setAppliedFilters([...curFilters])
    props.addToUrl && setUrlParams(curFilters, needClearAllDataLayer)
    props.onFilter(curFilters)
    if (props.handleScroll) props.handleScroll()
  }

  const handleFilterCheckbox = (checked, obj, facet, filter) => {
    handleFilter(checked, obj)
    addDataLayer({
      title: isSelected(obj) ? "filter applied" : "filter removed",
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
        appliedFilters: getAppliedFiltersForAnalytics(appliedFilters),
        facetName: facetLabels[`${facet}`].toLowerCase(),
        filterName: filter.toLowerCase(),
      },
    })
  }

  const setUrlParams = (filters, needClearAllDataLayer) => {
    let query = ""
    if (filters.length > 0) {
      filters.forEach((filter, i) => {
        let values = [...filter.value]
        if (filter.value.indexOf(props.attributevalue) !== -1) {
          let valueIndex = values.indexOf(props.attributevalue)
          values.splice(valueIndex, 1)
        }
        if (values.length !== 0)
          query += `${filter.facet}=${
            filter.facet === "Price_Range"
              ? filter.value
              : encodeURIComponent(values)
          }${i !== filters.length - 1 ? "&" : ""}`
      })
      window.history.replaceState(
        window.location.pathname,
        document.title,
        query.toString().length === 0
          ? window.location.pathname
          : `?${query.toString()}`
      )
      if (props.resetTitle) props.resetTitle()
    } else {
      clearAllFilters(needClearAllDataLayer)
    }
  }

  const handleCollapse = (facet, state) => {
    addDataLayer({
      title: state ? "accordion expand" : "accordion collapse",
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
        facetName: facetLabels[`${facet}`].toLowerCase(),
      },
    })
    setCollapse(prevCollapse => ({ ...prevCollapse, [facet]: state }))
  }

  const clearAllFilters = (needClearAllDataLayer = true) => {
    needClearAllDataLayer &&
      addDataLayer({
        title: props.texts.clearAll.toLowerCase(),
        cart_ID: props?.cartId,
        filterProps: {
          isFilter: true,
        },
      })
    setAppliedFilters([])
    setCollectionFilterValue("")
    props.onFilter([])
    window.history.replaceState({}, document.title, window.location.pathname)
    if (props.resetTitle) props.resetTitle()
  }

  const handleShowMore = () => {
    addDataLayer({
      title: (showMore
        ? props.texts.showLess
        : props.texts.showMore
      ).toLowerCase(),
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
      },
    })
    if (showMore) {
      const newCollapseState = {}
      facets.forEach((facet, i) => {
        if (i > 4) newCollapseState[facet[0]] = false
      })
      setCollapse(prevCollapse => ({ ...prevCollapse, ...newCollapseState }))
    }
    setShowMore(!showMore)
  }

  useEffect(() => {
    if (showMore) {
      document.getElementById("kf-filter-facets")?.childNodes &&
        document
          .getElementById("kf-filter-facets")
          .childNodes[7]?.childNodes[0]?.focus()
    }
  }, [showMore])

  const formatPriceRange = filter => {
    let values = filter.match(/\d+/g)
    return `$${values[0]} - $${values[1]}`
  }

  useEffect(() => {
    if (isMobile && !isTablet) {
      props.showFilter
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "visible")
    } else if (isTablet && !props.isLandscape) {
      props.showFilter
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "visible")
    }
  }, [props.showFilter])

  const filterChipsClearHandler = (facet, filter) => {
    handleFilter(false, { facet: facet, display: filter }, false)
    addDataLayer({
      title: "filter canceled",
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
        facetName: facetLabels[`${facet}`].toLowerCase(),
        filterName: filter.toLowerCase(),
        appliedFilters: getAppliedFiltersForAnalytics(appliedFilters),
      },
    })
  }

  const showAllCollectionHandler = (title, facetName) => {
    addDataLayer({
      title: title.toLowerCase(),
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
      },
    })
    setShowAllCollection({
      ...showAllCollection,
      [facetName]: !showAllCollection[facetName],
    })
  }

  const printHandler = () => {
    addDataLayer({
      title: props.texts.print.toLowerCase(),
      cart_ID: props?.cartId,
      filterProps: {
        isFilter: true,
      },
    })
    window.print()
  }

  const handleChange = (event, facetName) => {
    if (event.target.value === "") {
      setCollectionFilterValue({ ...collectionFilterValue, [facetName]: "" })
      return
    }
    if (event.target.value.length >= 2 || event.key === "Enter") {
      setCollectionFilterValue({
        ...collectionFilterValue,
        [facetName]: event.target.value,
      })
    }
  }
  const handleSearch = (event, facetName, facetLabelNames) => {
    event.target.placeholder = `Search ${
      facetLabelNames && facetLabelNames[facetName]
    }`
    if (event.target.value.length < 3) {
      setCollectionFilterValue({
        ...collectionFilterValue,
        [facetName]: event.target.value,
      })
    }
  }
  const facetLabels = props.facetLabels
  return (
    <div className={cx("filter", !showMore && "filter--show-less")}>
      <div className="filter__inner-container">
        <div className="inspiration-list__controls filter__mobile-header">
          <button className="inspiration-list__filter-toggle">
            <img
              src={filterIcon.src}
              className="inspiration-list__filter-toggle-icon"
              role="presentation"
              alt="Toggle Filter"
            />
            <span>
              {props.texts.filters}{" "}
              {props.selectedFilterCount > 0 &&
                ` (${props.selectedFilterCount})`}
            </span>
          </button>
          <img
            src={closeIcon.src}
            className="inspiration-list__close-icon"
            alt="Close Filter"
            onClick={() => props.close(false)}
          />
        </div>

        <div className="filter__chips">
          {appliedFilters.map(facet => {
            return facet.display.map(filter => (
              <div className="filter__chips-tag" key={filter}>
                <span>
                  {" "}
                  {filter === "Yes" || filter === "No"
                    ? formatFacetName(facet["facet"], filter)
                    : filter}
                </span>
                <img
                  src={closeIcon.src}
                  tabIndex="0"
                  role="button"
                  aria-label={`Remove filter ${
                    filter === "Yes" || filter === "No"
                      ? formatFacetName(facet["facet"], filter)
                      : filter
                  }`}
                  className="filter__chips-close-icon"
                  onClick={() => filterChipsClearHandler(facet.facet, filter)}
                />
              </div>
            ))
          })}
          {appliedFilters.length > 0 && (
            <div
              className="filter__chips-clear-all"
              tabIndex="0"
              role="button"
              aria-label={`${props.texts.clearAll} ${props.texts.filters}`}
              onClick={clearAllFilters}
            >
              {props.texts.clearAll}
            </div>
          )}
        </div>
        <div id="kf-filter-facets">
          {facets.map(facet => (
            <Collapsible
              role="group"
              tabIndex="0"
              open={collapse[facet[0]]}
              onTriggerOpening={() => handleCollapse(facet[0], true)}
              onTriggerClosing={() => handleCollapse(facet[0], false)}
              key={facet}
              openedClassName="is-open"
              trigger={
                <div aria-expanded={collapse[facet[0]] ? true : false }>
                  <span>
                    {facetLabels && facetLabels[`${facet[0]}`].toUpperCase()}
                  </span>{" "}
                  {plus}
                </div>
              }
              transitionTime={400}
              easing="ease-in-out"
            >
              {facet[1].map((filter, i, arr) => {
                if (i % 2 === 0) {
                  let displayText = null
                  if (facet[0] === "Price_Range") {
                    displayText = formatPriceRange(filter)
                  }
                  if (
                    facet[0] === "Color_Family" ||
                    facet[0] === "colorList_ss"
                  ) {
                    displayText = filter.split("|")[0]
                  }
                  if (
                    !filter
                      .toLowerCase()
                      .includes(
                        collectionFilterValue?.[facet[0]]?.toLowerCase() || ""
                      )
                  ) {
                    if (i === 0) {
                      return (
                        <React.Fragment>
                          <div className="inputWithIcon">
                            <input
                              type="text"
                              id="search-collections"
                              name="search-collections"
                              className="form__input search-collections"
                              onKeyUp={e => handleChange(e, facet[0])}
                              onBlur={e =>
                                handleSearch(e, facet[0], facetLabels)
                              }
                              placeholder={`Search ${
                                facetLabels && facetLabels[`${facet[0]}`]
                              }`}
                              onFocus={e => (e.target.placeholder = "")}
                              ref={collectionSearchVal}
                              aria-label={`Search ${
                                facetLabels && facetLabels[`${facet[0]}`]
                              }`}
                            />
                            <img
                              role="presentation"
                              className="search-icon"
                              src={searchIcon.src}
                              alt="search-icon"
                            />
                            <img
                              src={closeIcon.src}
                              className="search-collections__close-icon"
                              alt="Close Filter"
                              role="button"
                              tabIndex="0"
                              onClick={() => {
                                setCollectionFilterValue({
                                  ...collectionFilterValue,
                                  [facet[0]]: "",
                                })
                                collectionSearchVal.current.value = ""
                              }}
                            />
                          </div>
                        </React.Fragment>
                      )
                    }
                    return
                  }

                  if (
                    i > 10 &&
                    !showAllCollection[facet[0]] &&
                    !filter
                      .toLowerCase()
                      .includes(
                        collectionFilterValue?.[facet[0]]?.toLowerCase() || null
                      )
                  ) {
                    if (i > 12) {
                      return
                    }
                    return (
                      <button
                        className="filter__show-more"
                        onClick={() => {
                          showAllCollectionHandler(
                            props.texts.viewAll,
                            facet[0]
                          )
                        }}
                      >
                        {props.texts.viewAll}
                      </button>
                    )
                  }

                  let obj = {
                    facet: facet[0],
                    value: filter,
                    display: displayText ?? filter,
                  }
                  let facetName = formatFacetName(facet[0])

                  return (
                    <React.Fragment>
                      {i === 0 && arr.length > 11 && (
                        <div className="inputWithIcon">
                          <input
                            type="text"
                            id="search-collections"
                            name="search-collections"
                            className="form__input search-collections"
                            onKeyUp={e => handleChange(e, facet[0])}
                            onBlur={e => handleSearch(e, facet[0], facetLabels)}
                            placeholder={`Search ${
                              facetLabels && facetLabels[`${facet[0]}`]
                            }`}
                            onFocus={e => (e.target.placeholder = "")}
                            ref={collectionSearchVal}
                            aria-label={`Search ${
                              facetLabels && facetLabels[`${facet[0]}`]
                            }`}
                          />
                          <img
                            role="presentation"
                            className="search-icon"
                            src={searchIcon.src}
                            alt="search-icon"
                          />
                          <img
                            src={closeIcon.src}
                            className="search-collections__close-icon"
                            alt="Close Filter"
                            role="button"
                            onClick={() => {
                              setCollectionFilterValue({
                                ...collectionFilterValue,
                                [facet[0]]: "",
                              })
                              // collectionSearchVal.current.value = ""
                            }}
                            tabIndex={0}
                          />
                        </div>
                      )}
                      <Checkbox
                        key={filter}
                        id={facet[0] + filter}
                        checkBoxAria={`${obj.display} (${arr[i + 1]}) Selecting this checkbox will update the ${obj.display} ${facetName} products`}
                        tabIndex={collapse[facet[0]] ? 0 : -1}
                        value={`${obj.display} (${arr[i + 1]})`}
                        onChange={e =>
                          handleFilterCheckbox(
                            e.target.checked,
                            obj,
                            facet[0],
                            filter
                          )
                        }
                        checked={isSelected(obj)}
                        swatch={
                          facet[0] === "Color.Finish" ||
                          facet[0] === "Color" ||
                          facet[0] === "Finish" ||
                          facet[0] === "Color_Family" ||
                          facet[0] === "colorList_ss"
                            ? props.colors[filter]
                            : null
                        }
                      />
                      {showAllCollection[facet[0]] &&
                        i === facet[1].length - 2 && (
                          <button
                            className="filter__show-more"
                            onClick={() => {
                              showAllCollectionHandler(
                                props.texts.viewLess,
                                facet[0]
                              )
                            }}
                          >
                            {props.texts.viewLess}
                          </button>
                        )}
                    </React.Fragment>
                  )
                }
              })}
            </Collapsible>
          ))}
        </div>

        {facets.length > 7 ? (
          <button className="filter__show-more" onClick={handleShowMore}>
            {showMore ? props.texts.showLess : props.texts.showMore}
          </button>
        ) : (
          ""
        )}

        {props.discontinuedCheck && (
          <div className="filter__hide-discontinued">
            <div>
              <Checkbox
                id="discontinued"
                onChange={e =>
                  handleFilter(e.target.checked, {
                    facet: "Available_Now",
                    value: "true",
                    display: "Discontinued",
                  })
                }
                checked={isSelected({
                  facet: "Available_Now",
                  value: "true",
                  display: "Discontinued",
                })}
                value={props.texts.hideDiscontinued}
              />
            </div>
          </div>
        )}

        {props.page !== "article" &&
          !props.isCurated &&
          (props.buyingGuideDescription ||
            props.buyingGuideLink ||
            props.buyingGuideFieldLabel) && (
            <div className="filter__buying-guide d-none d-sm-none d-md-block">
              <h3>{entityToCharacter(props.buyingGuideDescription)}</h3>
              <a
                href={getShortenedUrl(props.buyingGuideLink)}
                target={props.newTab && "_blank"}
              >
                {props.buyingGuideFieldLabel}
              </a>
            </div>
          )}

        <div className="filter__print-and-share">
          {(props.displayPrint !== undefined ? props.displayPrint : true) && (
            <span
              role="button"
              onClick={printHandler}
              tabIndex="0"
              aria-label={props.texts.print}
            >
              <img
                src={printIcon.src}
                alt={props.texts.print}
                role="presentation"
              />
              {props.texts.print}
            </span>
          )}
          {props.displayShare && (
            <span
              role="button"
              onClick={() => setShowSocialLink(!showSocialLink)}
              ref={shareImg}
              tabIndex="0"
              aria-label={props.texts.share}
            >
              <img
                src={shareIcon.src}
                alt={props.texts.share}
                role="presentation"
              />
              {props.texts.share}
            </span>
          )}
        </div>

        <SocialShare
          showModal={showSocialLink}
          id="kf-plp-filter"
          onClose={() => {
            setShowSocialLink(false)
            shareImg?.current.focus()
          }}
          shareBtn={shareImg}
          analyticData={JSON.parse(
            getSocialAnalyticsData({
              title: props.texts.share.toLowerCase(),
              isFilter: true,
            })
          )}
        />
      </div>
      <div className="filter__footer">
        <button
          className={cx(
            "filter__apply",
            appliedFilters.length > 0 && "filter__apply--active"
          )}
          disabled={appliedFilters.length < 1}
          onClick={() => props.close(false)}
        >
          {props.selectedFilterCount > 0
            ? `${props.texts.view} ${props.texts.results} (${props.totalResults})`
            : props.texts.viewResults}
        </button>
        <div className="filter__buying-guide d-block d-sm-block d-md-none">
          <h3>{props.buyingGuideDescription}</h3>
          <a
            href={getShortenedUrl(props.buyingGuideLink)}
            target={props.newTab && "_blank"}
          >
            {props.buyingGuideFieldLabel}
          </a>
        </div>
      </div>
    </div>
  )
}

export default Filter
